import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { decode } from "he";
import { Anchor } from "../anchor";
import { useRenderer } from "../renderer";
export const RichText = ({ className, document }) => {
    // Safety check for undefined document or content
    if (!document || !document.content) {
        return _jsx("div", { className: className });
    }
    return (_jsx("div", { className: className, children: Array.from(document.content)
            .map(mapNodeToReactElement)
            .reduce((acc, val) => acc.concat(val), []) }));
};
function mapNodeToReactElement(node, index) {
    var _a;
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Called within React context
    const renderer = useRenderer();
    switch (node.type) {
        case "blockquote":
            return [mapBlockquoteToReactElement(node, index)];
        case "bulletList":
            return [
                _jsx("ul", { children: node.content.map(mapNodeToReactElement) }, `ul-${index}`)
            ];
        case "heading":
            return [mapHeadingToReactElement(node, index)];
        case "listItem":
            return [
                _jsx("li", { children: node.content.map(mapNodeToReactElement) }, `li-${index}`)
            ];
        case "paragraph":
            return [
                _jsx("p", { children: (_a = node.content) === null || _a === void 0 ? void 0 : _a.map(mapNodeToReactElement) }, `p-${index}`)
            ];
        case "rule":
            return [_jsx("hr", { role: "presentation" }, `hr-${index}`)];
        case "text":
            return mapTextToReactElement(node, index);
        case "orderedList":
            return [
                _jsx("ol", { children: node.content.map(mapNodeToReactElement) }, `ol-${index}`)
            ];
        case "bxpEmbeddedViewBlock":
            return [
                _jsx(Fragment, { children: renderer(node.model) }, `block-${index}`)
            ];
        case "bxpEmbeddedViewInline":
            return [
                _jsx(Fragment, { children: renderer(node.model) }, `inline-${index}`)
            ];
    }
}
function mapBlockquoteToReactElement({ content }, index) {
    return (_jsx("blockquote", { children: content.map(mapNodeToReactElement) }, `blockquote-${index}`));
}
function mapHeadingToReactElement({ attrs, content = [] }, index) {
    const children = content.map(mapNodeToReactElement);
    switch (attrs.level) {
        case 1:
            return _jsx("h1", { children: children }, `h1-${index}`);
        case 2:
            return _jsx("h2", { children: children }, `h2-${index}`);
        case 3:
            return _jsx("h3", { children: children }, `h3-${index}`);
        case 4:
            return _jsx("h4", { children: children }, `h4-${index}`);
        case 5:
            return _jsx("h5", { children: children }, `h5-${index}`);
        case 6:
            return _jsx("h6", { children: children }, `h6-${index}`);
    }
}
function mapTextToReactElement({ text, marks = [] }, index) {
    const [mark, ...otherMarks] = marks;
    if (mark) {
        const children = mapTextToReactElement({
            type: "text",
            text,
            marks: otherMarks
        }, index);
        switch (mark.type) {
            case "code":
                return [_jsx("code", { children: children }, `code-${index}`)];
            case "em":
                return [_jsx("em", { children: children }, `em-${index}`)];
            case "strong":
                return [_jsx("strong", { children: children }, `strong-${index}`)];
            case "underline":
                return [_jsx("u", { children: children }, `u-${index}`)];
            case "link":
                return [
                    _jsx(Anchor, { href: mark.attrs.href, children: children }, `a-${index}`)
                ];
        }
    }
    else {
        const [firstChunk, ...otherChunks] = text.split("\n");
        if (otherChunks.length > 0) {
            const otherElements = otherChunks
                .map((otherChunk, _index) => [
                _jsx("br", {}, `br-${_index}`),
                _jsx(Fragment, { children: decode(otherChunk || "") }, `other-fragment-${_index}`)
            ])
                .reduce((acc, val) => acc.concat(val), []);
            return [
                _jsx(Fragment, { children: decode(firstChunk || "") }, `first-fragment-${index}`),
                ...otherElements
            ];
        }
        else {
            return [
                _jsx(Fragment, { children: decode(text) }, `fragment-${index}`)
            ];
        }
    }
}
//# sourceMappingURL=RichText.js.map